import type { FC, ReactNode } from 'react'

// Mock implementation of Next.js Head component for use in React apps
// This allows ChirpThemeProvider to work in non-Next.js environments
const Head: FC<{ children?: ReactNode }> = ({ children }) => <>{children}</>

export default Head
